
<ng-container *ngIf="{
  row: columnData | async
} as $">
<ng-container *ngIf="$.row && $.row.tsk_type">
<span>{{getEnumKeyByEnumValue($.row.tsk_type)}}</span>
</ng-container>


